import React from 'react';
import { UOMToggle } from './UOMToggle';
import { useUOM } from '../../contexts/UOMContext';

interface UOMSelectorProps {
  value?: string;
  onSelect?: (value: string) => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  useGlobalState?: boolean; // New prop to control whether to use global state
}

export const UOMSelector: React.FC<UOMSelectorProps> = ({
  value,
  onSelect,
  disabled = false,
  label = "Unit of Measurement",
  useGlobalState = false
}) => {
  const { uom, setUOM } = useUOM();

  const handleSelect = (selectedValue: string) => {
    if (useGlobalState) {
      setUOM(selectedValue as 'Imperial' | 'Metric');
    }
    if (onSelect) {
      onSelect(selectedValue);
    }
  };

  return (
    <UOMToggle
      label={label}
      value={useGlobalState ? uom : (value || 'Imperial')}
      onSelect={handleSelect}
      disabled={disabled}
      useGlobalState={useGlobalState}
    />
  );
};
